module.exports = __webpack_public_path__ + "static/img/a095.14dcd72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a095.jpg
// module id = /HPb
// module chunks = 0